// extracted by mini-css-extract-plugin
export default {"chargesAddContainer":"AssignCharge_chargesAddContainer__a2s3g","selectionContainer":"AssignCharge_selectionContainer__JYiLJ","submitButton":"AssignCharge_submitButton__OWraZ"};